export default __webpack_public_path__ + "static/media/download.eb57f9ee.svg";